module.exports = __webpack_public_path__ + "static/media/how-it-works-image-1-3.3deb630e.png";